import { styled } from '../../Utilities';
import { DetailsHeaderBase } from './DetailsHeader.base';
import { getStyles } from './DetailsHeader.styles';
export var DetailsHeader = styled(DetailsHeaderBase, getStyles, undefined, {
  scope: 'DetailsHeader'
});